import { useUser } from "$global-providers/user-provider/provider";
import { isDevEnvironment } from "$routes/_lib/environment";
import { isDemoOrg } from "$routes/_lib/is-demo-org";

export const useCanSeedDemoData = (): boolean => {
  const user = useUser();

  return isDevEnvironment() || isDemoOrg(user.organisationId);
};
